module.exports = __webpack_public_path__ + "img/14.189b0555.jpg";